import axios from "../../../config/axios";

class ApiClient {
    getUserInfo() {
        return axios.get('auth/user-info');
    }
}

export default ApiClient;


// WEBPACK FOOTER //
// ./src/common/auth/rbac/ApiClient.js